import React from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  Step,
  StepLabel,
  Stepper,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const steps = [
  "Select campaign settings",
  "Create an ad group",
  "Create an ad",
];

const AlternativeLabelStepper = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Alternative label
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          Labels can be placed below the step icon by setting the
          alternativeLabel prop on the Stepper component.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              " const steps = [\n" +
              '  "Select campaign settings",\n' +
              '  "Create an ad group",\n' +
              '  "Create an ad",\n' +
              "];             " +
              "" +
              "<Stepper activeStep={1} alternativeLabel>\n" +
              "                {steps.map((label) => (\n" +
              "                  <Step key={label}>\n" +
              "                    <StepLabel>{label}</StepLabel>\n" +
              "                  </Step>\n" +
              "                ))}\n" +
              "              </Stepper>"
            }
          >
            <Box sx={{ width: "100%" }}>
              <Stepper activeStep={1} alternativeLabel>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default AlternativeLabelStepper;
